module.exports = __webpack_public_path__ + "img/image2.22d3f5d0.webp";